import {useTranslation} from 'react-i18next';
import {format} from 'date-fns';

import {WorkdayCollapsibleTile} from '../WorkdayCollapsibleTile';
import {Workday} from '@lib/store/src/data/timeslots/apiTypes';
import {getParkingReservationByDate, useAppSelector} from '@lib/store';
import {isOfficeWorkday} from '@lib/store/src/data/timeslots/utils';
import {ParkingReservationTile} from './ParkingReservationTile';

interface WorkdayReservationsSectionProps {
  workday: Workday | undefined;
  date: Date;
}

export const WorkdayParkingSection = ({workday, date}: WorkdayReservationsSectionProps) => {
  const {t} = useTranslation();

  const dateKey = format(date, 'yyyy-MM-dd');
  const parkingReservation = useAppSelector((state) => getParkingReservationByDate(state, dateKey));

  const isEmpty = !workday || !parkingReservation;

  if (isEmpty || !isOfficeWorkday(workday)) {
    return null;
  }

  return (
    <WorkdayCollapsibleTile
      handle={t('timeslots:ParkingBooking', {count: 1})}
      icon="car"
      contentClassName="p-0"
      handleClassName="border-t">
      <ParkingReservationTile
        workday={workday}
        parkingReservation={parkingReservation}
        selectedDate={dateKey}
      />
    </WorkdayCollapsibleTile>
  );
};
